import React, { Component } from 'react';
import sentGAEvent from '@/ga';
import VideoCompressWorkContentRender from './children/VideoCompressWorkContentRender';
import Utils from '@/utils';
import '@/assets/videoCompress.less';

class VideoCompressWorkContentFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
      resolutionList: [
        { key: '240p', value: 76800, rule: '320x240' },
        { key: '360p', value: 172800, rule: '480x360' },
        { key: '480p', value: 307200, rule: '640x480' },
        { key: '720p', value: 921600, rule: '1280x720' },
        { key: '1080p', value: 2073600, rule: '1920x1080' },
      ],
    };
  }

  handleVideoObjClose = () => {
    if (this.props.submitting) {
      Utils.cancelRequsetProcess(this.props.cancelProcessCallBack);
      this.props.cancelProcessCallBack();
      if (!this.props.videoCompressObj.uploadStatus) {
        this.props.handleVideoCompressObjChange(null);
        sentGAEvent({
          category: 'Upload',
          action: 'LoadCancel',
          label:
            (this.props.videoCompressObj.fileObj.size / 1024 / 1024).toFixed(
              2
            ) +
            'm_' +
            (new Date().getTime() - this.props.startTime.upload) / 1000 +
            's',
        });
      }
      // else{
      // sentGAEvent({
      //   category: "Upload",
      //   action: "LoadCancel",
      //   label: (new Date().getTime() - this.props.startTime.videoCompress) / 1000,
      // });
      // }
    } else {
      this.props.handleVideoCompressObjChange(null);
    }
    sentGAEvent({
      category: 'EnterFuncPage',
      action: '24VC_EnterFuncPage',
      label: 'Null',
    });
  };

  handleSubmit = () => {
    sentGAEvent({
      category: 'compress_click',
      action: 'compress_click',
    });
    this.props.handleSubmit();
  };

  render() {
    return (
      <VideoCompressWorkContentRender
        quality={this.props.quality}
        frameRate={this.props.frameRate}
        resolution={this.props.resolution}
        resolutionList={this.state.resolutionList}
        submitting={this.props.submitting}
        videoCompressObj={this.props.videoCompressObj}
        handleVideoObjClose={this.handleVideoObjClose}
        handleChangeResolution={this.props.handleChangeResolution}
        handleChangeQuality={this.props.handleChangeQuality}
        handleChangeFrameRate={this.props.handleChangeFrameRate}
        handleSubmit={this.handleSubmit}
        cancelProcessCallBack={this.props.cancelProcessCallBack}
        processText={this.props.processText}
      />
    );
  }
}

export default VideoCompressWorkContentFunction;
